import { Page, TextStyle, Button, Card } from '@shopify/polaris';
import WalletBIC from '../../assets/icons/walletBIC.svg';
import WalletDownload from '../../assets/icons/walletDownload.svg';
import WalletIncoming from '../../assets/icons/walletIncoming.svg';
import WalletOutgoing from '../../assets/icons/walletOutgoing.svg';
import WalletTemplates from '../../assets/icons/walletTemplates.svg';
import WalletUIC from '../../assets/icons/walletUIC.svg';
import styles from './wallet.module.scss';
import { clevertapEventPush, CT_EVENT_IDS } from '../../utils/clevertapUtils';
import DateFilter from '../Analytics_MessageLogs/Analytics/DateFilter';
import { useState } from 'react';
import AddBalance from './AddBalance';

function Wallet(props: any) {
  const [page, setPage] = useState(0);
  let shop = JSON.parse(localStorage.getItem('shop') || '{}');

  const walletUsageCards = [
    {
      title: 'Conversations (BIC)',
      count: '22000',
      imgSrc: WalletBIC,
    },
    {
      title: 'Conversations (UIC)',
      count: '21000',
      imgSrc: WalletUIC,
    },
    {
      title: 'Outgoing',
      count: '2800',
      imgSrc: WalletOutgoing,
    },
    {
      title: 'Incoming',
      count: '5000',
      imgSrc: WalletIncoming,
    },
    {
      title: 'Templates',
      count: '140',
      imgSrc: WalletTemplates,
    },
  ];

  const walletUsageCardElement = (card: any, index: any) => {
    return (
      <Card sectioned key={index}>
        <div className={styles.wltUsageCard}>
          <div className={styles.wltUsageCardContainer}>
            <div className={styles.wltUsageNumber}>
              <TextStyle variation='strong'>{card.count}</TextStyle>
            </div>
            <div className={styles.wltUsageText}>
              <TextStyle variation='subdued'>{card.title}</TextStyle>
            </div>
          </div>
          <div className={styles.wltUsageIcon}>
            <img src={card.imgSrc} alt='wltUsageIcon' />
          </div>
        </div>
      </Card>
    );
  };

  return page == 0 ? (
    <Page title='My Wallet'>
      <div className={styles.wltByline}>
        <TextStyle variation='subdued'>
          {
            'All your usage charges from Superlemon Product will be deducted from this wallet'
          }
        </TextStyle>
      </div>
      <div className={styles.wltAvlBalCard}>
        <Card sectioned>
          <TextStyle variation='strong'>{'Available Balance'}</TextStyle>
          <div className={styles.wltAvlBal}>
            <div className={styles.wltAvlBalNum}>{'$ 500'}</div>
            <div className={styles.wltAddBalBtn}>
              <Button primary onClick={() => setPage(1)}>
                Add Balance
              </Button>
            </div>
          </div>
        </Card>
      </div>

      <div className={styles.wltUsageSec}>
        <div className={styles.wltUsageTopBar}>
          <div className={styles.wltHeader}>{'Usage'}</div>
          <DateFilter
            showPicker={false}
            togglePopoverActive={() => {}}
            handleSubmit={() => {}}
            isSubmitting={false}
          />
          <div className={styles.wltUsageBtn}>
            <button className={styles.wltUsageBtnText}>
              <img
                src={WalletDownload}
                className={styles.wltUsageDownloadBtn}
                height={16}
              />
              <span>{'Download'}</span>
            </button>
          </div>
        </div>
        <div className={styles.wltUsageGrid}>
          {walletUsageCards.map((card, index) => {
            return walletUsageCardElement(card, index);
          })}
        </div>
      </div>

      <div className={styles.wltBillingHeader}>{'Billing History'}</div>
      <div className={styles.wltBillingSec}>
        <div className={styles.wltBillingCard}>
          <div className={styles.wltBillingCardTitle}>
            <TextStyle variation='strong'>{'Wallet Statement'}</TextStyle>
          </div>
          <div className={styles.wltBillingCardTxt}>
            <TextStyle variation='subdued'>
              {'You  can download your Wallet statement of last month here'}
            </TextStyle>
          </div>
          <button className={styles.wltBillingBtn}>
            {'Download Statement'}
          </button>
        </div>
        <div className={styles.wltBillingCard}>
          <div className={styles.wltBillingCardTitle}>
            <TextStyle variation='strong'>{'Last Recharge'}</TextStyle>
          </div>
          <div className={styles.wltBillingCardTxt}>
            <TextStyle variation='subdued'>
              {'You  can download your invoice of last month here'}
            </TextStyle>
          </div>
          <button className={styles.wltBillingBtn}>{'Download Invoice'}</button>
        </div>
      </div>
    </Page>
  ) : (
    <AddBalance setPage={setPage} userId={shop.userId} />
  );
}

export default Wallet;
